import { Toast } from "components/ToastShow/ToastAlert";
import { ENDPOINTS } from "utils/endpoints";
import { http } from "utils/http";

export const getJobStatus = (JobId) => http({
    method: "get",
    url: ENDPOINTS.cartable.jobStatus,
    params:{
        JobId : JobId
    }
}).then((res) => {
    return res.data
}).catch((err) => {

    return Promise.reject(err);
});